import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';
import Text from '../../components/text/Text';
import { formationsData } from '../../data/formations';
import './styles.css';

export function FormationPage() {
    const { id } = useParams();

    const formation = formationsData.find(f => f.id == id);

    if (!formation) {
        return <Navigate to="/" />;
    }

    const renderParagraphs = (text) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <body>
            <Navbar />
            <hr className='hr-min' />
            <div className='container'>
                <div className='content'>
                    <Text as='h1' fontSize={56} className='title-green'>{formation.title}</Text>
                    <div className='individual-formation-content'>
                        <div className='formation-details-text'>
                            {formation.fullTitle && <Text as='h3' fontSize={32}>{formation.fullTitle}</Text>}

                            {formation.extraInfo && <Text as='p' fontSize={24}>{renderParagraphs(formation.extraInfo)}</Text>}
                            <br />

                            <Text as='p' fontSize={24}>
                                {formation.details.date && <><strong>Data:</strong> {formation.details.date} <br /></>}
                                {formation.details.time && <><strong>Horário: </strong> {formation.details.time} <br /></>}
                                {formation.details.workload && <><strong>Carga Horária:</strong> {formation.details.workload} <br /></>}
                                {formation.details.location && <><strong>{formation.modality === 'Presencial' ? 'Local' : 'Formato'}:</strong> {formation.details.location}</>}
                            </Text> <br />

                            {formation.facilitators && formation.facilitators.length > 0 && (
                                <Text as='p' fontSize={24}>
                                    <strong>Facilitadores:</strong> <br /> {formation.facilitators.join(' e ')}
                                </Text>
                            )}
                            <br />

                            {formation.targetAudience && (
                                <Text as='p' fontSize={24}>
                                    <strong>Público de Interesse:</strong> <br /> {formation.targetAudience}
                                </Text>
                            )}
                            <br />

                            {formation.registration && (
                                <Text as='p' fontSize={24}>
                                    <strong>Período de Inscrições:</strong> {formation.registration.period} <br /> <strong>Link:</strong> <a href={formation.registration.link} target="_blank" rel="noopener noreferrer">{formation.registration.link}</a>
                                </Text>
                            )}
                            <br />

                            {formation.programContent && formation.programContent.length > 0 && (
                                <Text as='p' fontSize={24}>
                                    <strong>Conteúdo Programático:</strong> <br />
                                    {formation.programContent.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {item} <br />
                                        </React.Fragment>
                                    ))}
                                </Text>
                            )}
                        </div>
                        <img src={formation.image} alt={formation.title} className='individual-formation-image' />
                    </div>
                </div>
            </div>
            <Footer />
        </body>
    );
}